import { Injectable } from '@angular/core';
import { enUS, id } from 'date-fns/locale';
import { en_US, id_ID, NzI18nService } from 'ng-zorro-antd/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/en'; // Import English locale
import 'dayjs/locale/id'; // Import Indonesian locale

@Injectable({
  providedIn: 'root',
})
export class ZorroLanguageSwitcherService {
  constructor(private i18n: NzI18nService) {}

  switchZorroLanguage(lang: string) {
    switch (lang) {
      case 'id_ID':
        this.i18n.setLocale(id_ID);
        this.i18n.setDateLocale(id);
        dayjs.locale('id');
        break;
      default:
        this.i18n.setLocale(en_US);
        this.i18n.setDateLocale(enUS);
        dayjs.locale('en');
    }
  }
}
